import React from 'react';
import PropTypes from 'utils/propTypes';

import classNames from 'classnames';

import { Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';

const ProgressWidget = ({
  bgColor,
  icon: Icon,
  iconProps,
  title,
  subtitle,
  className,
  progress,
  active,
  ...restProps

}) => {
  const classes = classNames('cr-widget', className, {
    [`bg-${bgColor}`]: bgColor,
    'active': active
  });
  return (
    <Card className={classes} {...restProps}>

      <CardBody style={{width:'78%'}}>
        <CardTitle>{title}</CardTitle>
        <CardSubtitle>{subtitle}</CardSubtitle>
      </CardBody>

      <CardBody className="cr-widget__icon">
        <Icon size={iconProps.size} {...iconProps} />
        <div style={{ color:iconProps.style.color, textAlign: 'center', fontSize: 12 }}>{(progress && progress.value)?progress.value:0}%</div>
      </CardBody>

    </Card>
  );
};

ProgressWidget.propTypes = {
  bgColor: PropTypes.string,
  icon: PropTypes.component,
  iconProps: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  active: PropTypes.bool,
  progress: PropTypes.object,
};

ProgressWidget.defaultProps = {
  active: false,
  bgColor: 'primary',
  icon: 'span',
  iconProps: { size: 30, style: { color: '#00aee4' } },

};

export default ProgressWidget;
